import { Component, ElementRef, inject, Input } from '@angular/core';
import { School } from 'src/app/core/models/school';
import { SchoolTemplateDesign } from 'src/app/core/models/templates';
import { CommonService } from 'src/app/core/services/api/common.service';
import { LicenseCategoryModel } from 'src/app/core/services/api/school-template-designs.service';

@Component({
  selector: 'app-license-product-category',
  templateUrl: './license-product-category.component.html',
  styleUrls: ['./license-product-category.component.scss']
})
export class LicenseProductCategoryComponent {
  @Input({required: true}) school: School;
  @Input({required: true}) design: SchoolTemplateDesign;
  @Input({required: true}) category: LicenseCategoryModel;
  commonService = inject(CommonService);
  elementRef = inject(ElementRef);

  private datetime = new Date();

  public getCachelessUrl(url: string): string {
    return url + '?v=' + this.datetime.getTime();
  }

}
